var _defs, _g, _g2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrigger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 5.37px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.29,80.44c8.59-7.44,14.05-18.41,14.05-30.64,0-11.83-5.09-22.48-13.2-29.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.31,29.11c5.88,4.98,9.63,12.4,9.63,20.69,0,8.76-4.2,16.55-10.66,21.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.27,71.31c6.47-4.96,10.66-12.75,10.66-21.51,0-8.29-3.75-15.71-9.63-20.69"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.43,19.91c-8.31,7.75-13.35,18.92-12.9,31.14.44,11.82,5.93,22.28,14.3,29.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.31,70.87c-6.06-4.76-10.08-12.04-10.39-20.32-.33-8.76,3.58-16.69,9.86-21.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.78,28.66c-6.28,5.2-10.18,13.13-9.86,21.89.31,8.28,4.33,15.56,10.39,20.32"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 50,
    cy: 50,
    r: 7.19
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrigger);
export default __webpack_public_path__ + "static/media/trigger.bdf9bf5e.svg";
export { ForwardRef as ReactComponent };